import React from 'react'
import { callToActionType } from '../../types'
import CallToActionSection from './call-to-action-section'
import style from './index.scss'

const CallToActionCategoryContainer = ({ callsToAction }) => {
  const listOfVendors = []
  const allCategories = [...listOfVendors]

  const areMainSectionsDisplayed = callsToAction.some(cta =>
    allCategories.includes(cta.category)
  )

  const moreCategory = callsToAction
    .filter(cta => !allCategories.includes(cta.category))
    .map(cta => cta.category)

  const sections = [
    {
      title: 'Pick up or Deliver with:',
      isMainCallToAction: false,
      listOfCategories: listOfVendors,
    },
    {
      title: areMainSectionsDisplayed ? 'More:' : undefined,
      isMainCallToAction: !areMainSectionsDisplayed,
      listOfCategories: moreCategory,
    },
  ]
  return (
    <div className={style.ctaContainer}>
      {sections.map(section => (
        <CallToActionSection
          {...section}
          callsToAction={callsToAction}
          key={section.title}
        />
      ))}
    </div>
  )
}

CallToActionCategoryContainer.propTypes = {
  callsToAction: callToActionType,
}
export default CallToActionCategoryContainer
